import { ErrorInfoSVG } from '@/Component/Common/SVGs/CommonSVG'

const ValidationMsg = (props) => {
    const { errorMsg } = props;
    return (
        <div className="flex items-center mt-2">
            <ErrorInfoSVG customClass={'mr-1'} />
            <span className="text-red-500 text-xs">
                {errorMsg}
            </span>
        </div>
    )
}

export default ValidationMsg
